import type {
  AgentAddAgentDocumentInput,
  AgentAgentKYCStartInput,
} from '../api'
import { api } from '../api'

const agentStartVideoKyc = async (data: AgentAgentKYCStartInput) => {
  return await api.v1.agentStartKyc(data)
}

const agentAddKycDocument = async (data: AgentAddAgentDocumentInput) => {
  return await api.v1.agentAddKycDocument(data)
}

export default {
  agentStartVideoKyc,
  agentAddKycDocument,
}
